import React, { useState } from "react";
import ContactImg from "../../resources/ContactImg.png";
import SalesIcon from "../../resources/SalesIcon.png";
import SupportIcon from "../../resources/SupportIcon.png";
import CustomerServiceIcon from "../../resources/CustomerServiceIcon.png";
import clsx from "clsx";
import {
  Grid,
  Typography,
  Button,
  Hidden,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  IconButton,
  Select,
  MenuItem,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { makeStyles } from "@material-ui/core/styles";
import RegisterImage from "../../resources/RegisterImage.png";
import LoginBtnIcon from "../../resources/LoginBtnIcon.png";

const useStyles = makeStyles((theme) => ({
  root: {},

  input_container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "22px",
    "& .input_subContainer": {
      width: "100%",
      "& .MuiFormControl-root": {
        width: "100%",
      },
    },
  },

  input_subContainer: {
    width: "49%",
    "& .MuiFormControl-root": {
      width: "100%",
      "& .MuiOutlinedInput-root > fieldset": {
        borderRadius: "0px",
      },
    },
  },

  contact_one: {
    height: "550px",
    width: "80%",
  },

  input_container_fullWidth: {
    width: "100%",
    height: "155px",
    marginBottom: "22px",
    "& .MuiFormControl-root": {
      width: "100%",
      "& .MuiOutlinedInput-root > fieldset": {
        borderRadius: "0px",
        height: "155px",
      },
    },
  },

  input_btnSubmit: {
    "& button": {
      height: "66px",
      background: "#F53838",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
      width: "100%",
      height: "66px",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
      fontFamily: "Rubik",
      textTransform: "none",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "25px",
      lineHeight: "30px",
      color: "#fff",
      borderRadius: "0px",

      "&:hover": {
        background: "#F83030",
      },
    },
  },

  AboutUs_title: {
    width: "186px",
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "33px",
    lineHeight: "39px",
    color: "#000000",
    marginBottom: "24px",
  },
  AboutUs_dash: {
    display: "block",
    width: "104px",
    height: "2px",
    background: "#F53838",
    marginBottom: "50px",
  },
  AboutUs_span: {
    color: "#F53838",
  },

  two: {
    minHeight: "540px",
    width: "86%",
    margin: "0 auto",
    "& .MuiGrid-item": {
      "& div": {
        width: "340px",
        height: "340px",
        boxShadow: "0px 22px 40px rgba(235, 235, 235, 0.5)",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
        padding: "10% 12%",

        "& h4": {
          fontFamily: "Rubik",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "26px",
          color: "#000000",
        },
        "& p": {
          fontFamily: "Rubik",
          fontStyle: "normal",
          fontWeight: "normal",
          fontSize: "18px",
          textAlign: "center",
          color: "#000000",
        },
      },
    },
  },

  three: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    height: "256px",
    width: "80%",
    "& button": {
      width: "549px",
      height: "107px",
      background: "#F53838",
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "34px",
      textAlign: "center",
      color: " #FFFFFF",
      borderRadius: "0px",
    },
  },

  [theme.breakpoints.down("sm")]: {
    three: {
      display: "flex",
      flexDirection: "column",
      height: "256px",
      width: "80%",
      "& button": {
        width: "80%",
        height: "107px",
        background: "#F53838",
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "34px",
        textAlign: "center",
        color: " #FFFFFF",
        borderRadius: "0px",
      },
    },
  },
  [theme.breakpoints.only("md")]: {},
}));

function Contact() {
  const classes = useStyles();
  return (
    <Grid container display="flex" alignItems="center" justify="center">
      <Grid item className={classes.contact_one}>
        <Grid container display="flex" alignItems="center" justify="center">
          <Grid item md={6} xs={12}>
            <div>
              <Typography variant="h2" className={classes.AboutUs_title}>
                Contact <span className={classes.AboutUs_span}>Us</span>
              </Typography>
              <span className={classes.AboutUs_dash}></span>
            </div>
            <div className={classes.input_container}>
              <div className={classes.input_subContainer}>
                <FormControl>
                  <TextField
                    id="name"
                    label="Full Name*"
                    variant="outlined"
                    color="secondary"
                  />
                </FormControl>
              </div>

              <div className={classes.input_subContainer}>
                <FormControl>
                  <TextField
                    id="email"
                    label="Email*"
                    variant="outlined"
                    color="secondary"
                  />
                </FormControl>
              </div>
            </div>

            <div className={classes.input_container}>
              <div className={classes.input_subContainer}>
                <FormControl>
                  <TextField
                    id="countryCode"
                    label="Country Code*"
                    variant="outlined"
                    color="secondary"
                  />
                </FormControl>
              </div>

              <div className={classes.input_subContainer}>
                <FormControl>
                  <TextField
                    id="phone"
                    label="Phone*"
                    variant="outlined"
                    color="secondary"
                  />
                </FormControl>
              </div>
            </div>
            <div className={classes.input_container_fullWidth}>
              <FormControl>
                <TextField
                  id="message"
                  label="Message*"
                  variant="standard"
                  color="secondary"
                  margin="none"
                  variant="outlined"
                />
              </FormControl>
            </div>

            <div className={classes.input_btnSubmit}>
              <Button variant="contained" color="primary">
                Submit
              </Button>
            </div>
          </Grid>
          <Hidden smDown>
            <Grid item md={6}>
              <img src={ContactImg} />
            </Grid>
          </Hidden>
        </Grid>
      </Grid>

      <Grid item md={12} sm={12}>
        <Grid
          container
          display="flex"
          alignItems="center"
          justify="space-evenly"
          className={classes.two}
        >
          <Grid item spacing={1}>
            <div>
              <img src={SalesIcon} />
              <h4>Sales Contact</h4>
              <p>
                Would you like to know more? Contact our sales team on
                sales@gpmesh.com
              </p>
            </div>
          </Grid>

          <Grid item spacing={1}>
            <div>
              <img src={SupportIcon} />
              <h4>Our Support</h4>
              <p>
                Would you like to know more? Contact our sales team on
                Support@gpmesh.com
              </p>
            </div>
          </Grid>

          <Grid item spacing={1}>
            <div>
              <img src={CustomerServiceIcon} />
              <h4>Talk to us!</h4>
              <p>
                Would you like to know more? Contact our sales team on
                sales@gpmesh.com
              </p>
            </div>
          </Grid>
        </Grid>
      </Grid>

      <Grid item className={classes.three}>
        <Button variant="contained" color="secondary">
          Live Chat With Us
        </Button>
        <Button variant="contained" color="secondary">
          FAQ’s
        </Button>
      </Grid>
    </Grid>
  );
}

export default Contact;
